import type {CreateExtArgs, EnvironmentContext} from '@wix/document-manager-core'
import type {EditImagesParams} from '@wix/document-services-types'
import {generateAndInjectImagesWorkflow} from './utils'
import {type EditImageParams, fetchEditedImagesWorkflow} from './requests'
import {ERRORS} from '../constants'

export const editImages = async (
    {serverFacade}: Pick<EnvironmentContext, 'serverFacade'>,
    createExtArgs: CreateExtArgs,
    {componentPointers, userPrompt, userRequestInfo, onSuccess, onError}: EditImagesParams
): Promise<void> => {
    return generateAndInjectImagesWorkflow<EditImageParams>(
        createExtArgs,
        serverFacade,
        componentPointers,
        (_key, url, width, height) => ({
            width_RunwareFlux: width.toString(),
            height_RunwareFlux: height.toString(),
            userImage: url,
            editRequest: userPrompt
        }),
        fetchEditedImagesWorkflow,
        {
            userRequestInfo,
            onSuccess,
            onError,
            caller: 'editImages',
            errorType: ERRORS.IMAGES.EDIT_IMAGES
        }
    )
}
